import { createSlice } from '@reduxjs/toolkit';
import { geChatRoomBuilder, getAllChatRoomsBuilder } from './builder';
import cryptoService from '../../../services/cryptoService';
import { CHAT_MESSAGE_TYPES } from '../../../utils/constants';

const initialState = {
  getAllChatRoomsPending: false,
  getChatRoomPending: false,

  hasUnSeenMessages: false,

  chatRooms: {
    data: [],
    maxReached: false,
    total: 0,
    page: 1,
  },
  chatRoom: {
    id: '',
    data: [],
    client: {},
    maxReached: true,
    page: 1,
    key: '',
  },
};
export const chatSlice = createSlice({
  name: 'chatInfo',
  initialState,
  reducers: {
    addMessageToChatRoom(state, action) {
      let msg = action.payload;
      //const userId = action.payload.senderId;
      state.chatRoom.data.unshift(msg);
      if (state.chatRoom.id === msg.chatRoomId) {
        state.chatRoom.data[0] = msg;

        // if (state.chatRoom.client.id === userId) {
        //state.chatRoom.data[i].chatRoomMembers[v].lastSeenMessageId = msg.id;
        // }
      }
      for (const [i, room] of state.chatRooms.data.entries()) {
        if (room.id === msg.chatRoomId) {
          room.lastActivity = msg.createdAt;
        }
      }
      const findChatRoom = state.chatRooms.data.find(chat => chat.id === msg.chatRoomId);

      if (findChatRoom) {
        let tmp = state.chatRooms.data.filter(chat => chat.id !== findChatRoom.id);
        tmp.unshift(findChatRoom);
        state.chatRooms.data = [...tmp];
      }
    },

    addReceivedMessageToChatRoom(state, action) {
      if (action.payload.customId) {
        //set message status to delivered
        console.log('CUSTOM');
      } else {
        let msg = action.payload.message;
        let key = '';
        if (state.chatRoom.id === msg.chatRoomId) {
          key = state.chatRoom.key;
        }

        if (msg.type === CHAT_MESSAGE_TYPES.PLAIN_TEXT) {
          msg.message = cryptoService.decrypt(key, msg.message.message);
        }

        // const userId = action.payload.id;
        let isChatOpened = false;
        if (state.chatRoom.id === msg.chatRoomId) {
          state.chatRoom.data.unshift(msg);
          isChatOpened = true;
        }

        for (const [i, chatRoom] of state.chatRooms.data.entries()) {
          if (chatRoom.id === msg.chatRoomId) {
            state.chatRooms.data[i].messages[0] = msg;
            if (!isChatOpened) {
              state.chatRooms.data[i].unseenMessage = true;
            }
            for (const [v, chatRoomMember] of state.chatRooms.data[i].chatRoomMembers.entries()) {
              if (chatRoomMember.vendor) {
                state.chatRooms.data[i].chatRoomMembers[v].lastSeenMessageId = msg.id;
              }
            }
          }
        }

        const findChatRoom = state.chatRooms.data.find(chat => chat.id === msg.chatRoomId);

        if (findChatRoom) {
          let tmp = state.chatRooms.data.filter(chat => chat.id !== findChatRoom.id);
          tmp.unshift(findChatRoom);
          state.chatRooms.data = [...tmp];
        }

        state.hasUnSeenMessages = isChatOpened ? state.hasUnSeenMessages : true;
      }
    },
    resetSelectedChatRoom(state) {
      state.chatRoom = {
        id: '',
        data: [],
        client: {},
        maxReached: true,
        page: 1,
        key: '',
      };
    },
  },
  extraReducers: builder => {
    getAllChatRoomsBuilder(builder);
    geChatRoomBuilder(builder);

    builder.addCase('logout', () => initialState);
  },
});

export const selectAllChatRooms = state => state.chatInfo.chatRooms;
export const selectGetAllChatRoomsPending = state => state.chatInfo.getAllChatRoomsPending;
export const selectChatRoom = state => state.chatInfo.chatRoom;
export const selectGetChatRoomPending = state => state.chatInfo.getChatRoomPending;
export const selectHasUnSeenMessages = state => state.chatInfo.hasUnSeenMessages;

export const { addMessageToChatRoom, addReceivedMessageToChatRoom, resetSelectedChatRoom } = chatSlice.actions;

export default chatSlice.reducer;
